export const SALES_EMAIL = `email@placeholder.com`;
